import {nanoid} from "nanoid"
const ___uuid___ = "___uuid___";

export default function () {
  let uuid = localStorage.getItem(___uuid___);
  if (!uuid){
    uuid = nanoid();
    localStorage.setItem(___uuid___,uuid);
  }
  return uuid;
}



// WEBPACK FOOTER //
// ./src/utils/uuid.js